<template>
  <div class="theme-colorselect m-1 mt-0">
    <div class="theme-container-background"></div>
    <div class="pickr-container-background"></div>
  </div>
</template>
<script>
// import Pickr from "@simonwep/pickr/dist/pickr.es5.min";
export default {
  data() {
    return {};
  },
  mounted() {
    //switcher color pickers
  },
};
</script>
